import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"label\"><a href=\"#badge\"></a> Label </h1><div class=\"py-5\"> Set symbol lavel within <code>.symbol-label</code> element and style it with text and background utility classes: </div><div class=\"py-5\"><div class=\"rounded border p-10 pb-0 d-flex flex-wrap\"><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label fs-2 fw-bold text-success\">A</div></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label fs-2 fw-bold bg-danger text-inverse-danger\"> L </div></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label fs-2 fw-bold text-danger\">C</div></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label fs-2 fw-bold bg-primary text-inverse-primary\"> T </div></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label fs-2 fw-bold text-warning\">X</div></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label fs-2 fw-bold bg-info text-inverse-info\"> S </div></div></div></div>", 3)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <div class="symbol symbol-50px">
          <div class="symbol-label fs-2 fw-bold text-success">A</div>
        </div>

        <div class="symbol symbol-50px">
          <div class="symbol-label fs-2 fw-bold bg-danger text-inverse-danger">
            L
          </div>
        </div>

        <div class="symbol symbol-50px">
          <div class="symbol-label fs-2 fw-bold text-danger">C</div>
        </div>

        <div class="symbol symbol-50px">
          <div
            class="symbol-label fs-2 fw-bold bg-primary text-inverse-primary"
          >
            T
          </div>
        </div>

        <div class="symbol symbol-50px">
          <div class="symbol-label fs-2 fw-bold text-warning">X</div>
        </div>

        <div class="symbol symbol-50px">
          <div class="symbol-label fs-2 fw-bold bg-info text-inverse-info">
            S
          </div>
        </div>
        `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}